export default __webpack_public_path__ + "static/media/elevate-bbl-4.331f4e8f.png";